import { Modal, Box, Grid, Button } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  dataURLtoFile,
} from "../../services/serviceBase";
import { toast } from "react-hot-toast";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export default function AttachmentBoxInQCModal(props) {
  const { setLoading } = useLoading();
  const intl = useIntl();
  const navigate = useNavigate();

  const [activeAttachment, setActiveAttachment] = useState("");
  const [renderActiveAttachment, setRenderActiveAttachment] = useState("");
  const [currentDefectDetail, setCurrentDefectDetail] = useState(null);
  const [renderAttach, setRenderAttach] = useState([]);
  const [attachmentsList, setAttachmentsList] = useState([]);

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    //height: "85%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  useEffect(() => {
    if (props.boxInId != null && props.boxInId != "") {
      getAttachments(props.boxInId);
    }
  }, [props.openModal]);

  useEffect(() => {
    if (renderAttach.length > 0) {
      setActiveAttachment(renderAttach[0].hash);
    } else {
      setActiveAttachment(props.activeAttachment);
      setRenderActiveAttachment(props.activeAttachment);
    }
  }, [renderAttach]);

  const handleClose = () => {
    props.handleCloseModal();
  };

  const handleBefore = () => {
    var firstAttach = attachmentsList[0];
    var currentHash = activeAttachment != "" ? activeAttachment : firstAttach;
    var currentIndex = attachmentsList.findIndex((x) => x == currentHash);

    if (currentIndex > -1) {
      currentIndex = currentIndex - 1;
    }

    if (currentIndex >= 0) {
      currentHash = attachmentsList[currentIndex];
    } else {
      currentHash = attachmentsList[attachmentsList.length - 1];
    }

    setActiveAttachment(currentHash);
    getExistingDefectAttachments(currentHash);
  };

  const handleNext = () => {
    var firstAttach = attachmentsList[0];
    var currentHash = activeAttachment != "" ? activeAttachment : firstAttach;
    var currentIndex = attachmentsList.findIndex((x) => x == currentHash);

    if (currentIndex > -1) {
      currentIndex = currentIndex + 1;
    }

    if (currentIndex <= attachmentsList.length - 1) {
      currentHash = attachmentsList[currentIndex];
    } else if (attachmentsList.length > 0) {
      currentHash = attachmentsList[0];
    }

    setActiveAttachment(currentHash);
    getExistingDefectAttachments(currentHash);
  };

  function getExistingDefectAttachments(hash) {
    setLoading(true);
    axios
      .get(
        `/returnfiles/${props.idReturnFileHead}/boxinqc/attachments/${hash}`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        setLoading(false);
        var base64 = Buffer.from(response.data).toString("base64");
        setRenderActiveAttachment(base64);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }

  const handleImageClick = (e, hash) => {
    setActiveAttachment(hash);
  };

  const getAttachments = (boxInId) => {
    setLoading(true);
    axios
      .get(
        `returnfiles/${props.idReturnFileHead}/boxinqc/${boxInId}/attachments`
      )
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setAttachmentsList(response.data);

          const promises = response.data.map((x) =>
            getExistingDefectThumbnail(x)
          );
          Promise.all(promises).then((images) => {
            setLoading(false);
            setRenderAttach(images);
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getExistingDefectThumbnail = async (hash) => {
    setLoading(true);
    return axios
      .get(
        `/returnfiles/${props.idReturnFileHead}/boxinqc/thumbnails/${hash}`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        setLoading(false);
        var base64 = Buffer.from(response.data).toString("base64");
        return { attachment: base64, hash: hash };
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleDeleteAttachmentClick = (hash) => {
      if(!renderAttach || renderAttach.length <= 0) {
        return;
      }

      setLoading(true);
      axios
        .delete(`/returnfiles/${props.idReturnFileHead}/boxinqc/attachments/${hash}`)
        .then((response) => {
          setLoading(false);
          toast.success("Deleted!");
  
          let newRenderAttach = [];
          renderAttach.map((x) => newRenderAttach.push(x));
          const index = renderAttach.findIndex((x) => x.hash == hash);
          if (index > -1) {
            newRenderAttach.splice(index, 1);
          }
          setRenderAttach(newRenderAttach);
          setActiveAttachment("");
          setRenderActiveAttachment("");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, () => {
            errorToast(error, intl);
          });
        });
    };

  useEffect(() => {
    if (activeAttachment.length > 0) {
      getExistingDefectAttachments(activeAttachment);
    } else {
      setActiveAttachment(props.activeAttachment);
      setRenderActiveAttachment(props.activeAttachment);
    }
  }, [activeAttachment]);

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={props.boxInId + " - Attachments"} />
        <Grid container mt={1}>
          <Grid item xl={6}>
            <div id="attachmentContainer" style={{ border: "4px solid black"}}>
              {renderActiveAttachment.length > 0 ? (
                <img
                  src={`data:;base64,${renderActiveAttachment}`}
                  id="attachmentDetail"
                  style={{maxWidth: "100% !important", height: "auto !important" }}
                />
              ) : (
                <img
                  src={require("../../img/no_image.png")}
                  id="attachmentDetail"
                />
              )}
            </div>
          </Grid>
          <Grid item xl={6} xs={12} style={{ paddingLeft: 10 }}>
            <Grid
              container
              sx={{ color: "grey", p: 0.5, borderBottom: "4px solid" }}
            >
              <Grid item xs={1}>
                <IconButton
                  className="apeLigthBlueColor"
                  onClick={handleBefore}
                  disabled={activeAttachment.length == 0 ? true : false}
                >
                  <NavigateBeforeIcon fontSize="large" />
                </IconButton>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={1}>
                <IconButton
                  className="apeLigthBlueColor"
                  onClick={handleNext}
                  disabled={activeAttachment.length == 0 ? true : false}
                >
                  <NavigateNextIcon fontSize="large" />
                </IconButton>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              {renderAttach?.map((x, i) => {
                return (
                  <Grid item ml={1} xs={2}>
                    <img
                      src={`data:;base64,${x.attachment}`}
                      width={100}
                      height={100}
                      key={x.hash}
                      style={{ border: "1px solid grey" }}
                      onClick={(event) => handleImageClick(event, x.hash)}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Grid container pt={10}>
                <Grid item xs={12}>
                  <IconButton
                    sx={{ pl: 0 }}
                    onClick={() => {
                      handleDeleteAttachmentClick(activeAttachment);
                    }}
                  >
                    <DeleteForeverIcon
                      sx={{
                        fontSize: 37,
                        color: "white",
                        backgroundColor: "#007cd6",
                        borderRadius: 1,
                        paddingLeft: 1,
                        paddingRight: 1,
                      }}
                    />
                  </IconButton>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    {intl.formatMessage({ id: "General.Cancel" })}
                  </Button>
                </Grid>
              </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
